import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import {
  MdUpload,
  MdLogout,
  MdDownload,
  MdRefresh,
  MdCloudUpload
} from "react-icons/md";
import { comensalApi } from "../../../services/api/comensalApi";
import { clienteApi } from "../../../services/api/clienteApi";
import { comedorApi } from "../../../services/api/comedorApi";
import * as XLSX from "xlsx";
import "react-toastify/dist/ReactToastify.css";
import "../../../components/css/Dashboard.css";

const CargaMasivaComensales = () => {
  const navigate = useNavigate();
  const currentUser = JSON.parse(localStorage.getItem("user"));
  const selectedProject = JSON.parse(localStorage.getItem("selectedProject"));
  
  // Estados locales para clientes y comedores
  const [clientes, setClientes] = useState([]);
  const [comedores, setComedores] = useState([]);
  
  const [file, setFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isValidating, setIsValidating] = useState(false);
  const [progress, setProgress] = useState(0);
  const [results, setResults] = useState(null);
  const [fileValidationErrors, setFileValidationErrors] = useState([]);
  const [isFileValid, setIsFileValid] = useState(false);
  const [additionalData, setAdditionalData] = useState({
    id_cliente: undefined,
    id_comedor: undefined,
  });

  const showToast = (type, message) => {
    if (type === "success") {
      toast.success(message, { position: "bottom-right", autoClose: 3000 });
    } else if (type === "error") {
      toast.error(message, { position: "bottom-right", autoClose: 3000 });
    } else if (type === "info") {
      toast.info(message, { position: "bottom-right", autoClose: 3000 });
    } else if (type === "warning") {
      toast.warning(message, { position: "bottom-right", autoClose: 3000 });
    }
  };

  // Cargar clientes y comedores del proyecto
  useEffect(() => {
    const fetchData = async () => {
      if (selectedProject && selectedProject.id) {
        try {
          // Cargar clientes
          console.log("🔍 Cargando clientes para proyecto:", selectedProject.id);
          const clientesResponse = await clienteApi.getByProyectoRest(selectedProject.id);
          console.log("📋 Respuesta clientes:", clientesResponse.data);
          
          // Verificar estructura de clientes
          let clientesData = [];
          if (clientesResponse.data && Array.isArray(clientesResponse.data)) {
            clientesData = clientesResponse.data;
          } else if (clientesResponse.data && clientesResponse.data.data && Array.isArray(clientesResponse.data.data)) {
            clientesData = clientesResponse.data.data;
          }
          
          setClientes(clientesData);
          
          // Cargar comedores
          console.log("🔍 Cargando comedores para proyecto:", selectedProject.id);
          const comedoresResponse = await comedorApi.getByProyectoRest(selectedProject.id);
          console.log("🍽️ Respuesta comedores:", comedoresResponse.data);
          
          // Verificar estructura de comedores
          let comedoresData = [];
          if (comedoresResponse.data && Array.isArray(comedoresResponse.data)) {
            comedoresData = comedoresResponse.data;
          } else if (comedoresResponse.data && comedoresResponse.data.data && Array.isArray(comedoresResponse.data.data)) {
            comedoresData = comedoresResponse.data.data;
          }
          
          setComedores(comedoresData);
          
        } catch (error) {
          console.error("❌ Error cargando datos del proyecto:", error);
          showToast("error", "Error cargando clientes y comedores");
        }
      }
    };
    fetchData();
  }, [selectedProject?.id]);

  // Log para verificar el estado de clientes y comedores
  useEffect(() => {
    console.log("🔄 Estado clientes actualizado:", clientes);
    console.log("🔄 Cantidad de clientes:", clientes.length);
  }, [clientes]);

  useEffect(() => {
    console.log("🔄 Estado comedores actualizado:", comedores);
    console.log("🔄 Cantidad de comedores:", comedores.length);
  }, [comedores]);

  const handleFileChange = async (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileExtension = selectedFile.name.split('.').pop().toLowerCase();
      if (!['xlsx', 'xls'].includes(fileExtension)) {
        showToast("error", 'Por favor seleccione un archivo Excel válido (.xlsx o .xls)');
        e.target.value = '';
        return;
      }
      
      // Validar archivo en el backend
      setIsValidating(true);
      setFileValidationErrors([]);
      setIsFileValid(false);
      setResults(null);
      
      try {
        const validationResponse = await comensalApi.validateBulkUploadFile(selectedFile);
        
        if (validationResponse.data && validationResponse.data.success === false) {
          // Hay errores de validación
          const errors = validationResponse.data.errores_detallados || [];
          setFileValidationErrors(errors);
          setIsFileValid(false);
          setFile(null);
          e.target.value = '';
          showToast("error", validationResponse.data.message || "El archivo Excel tiene errores de validación");
        } else {
          // Archivo válido
          setFile(selectedFile);
          setFileValidationErrors([]);
          setIsFileValid(true);
          showToast("success", `Archivo "${selectedFile.name}" validado correctamente`);
        }
      } catch (error) {
        console.error('Error al validar archivo:', error);
        const errorMessage = error.response?.data?.message || error.message || "Error al validar el archivo";
        setFileValidationErrors([{
          fila: 1,
          errores: [errorMessage]
        }]);
        setIsFileValid(false);
        setFile(null);
        e.target.value = '';
        showToast("error", errorMessage);
      } finally {
        setIsValidating(false);
      }
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value.trim() === "" ? undefined : parseInt(e.target.value);
    setAdditionalData({ ...additionalData, [e.target.name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validaciones
    if (!file) {
      showToast("error", 'Por favor seleccione un archivo Excel');
      return;
    }

    if (!additionalData.id_cliente) {
      showToast("error", 'Por favor seleccione un cliente');
      return;
    }

    if (!additionalData.id_comedor) {
      showToast("error", 'Por favor seleccione un comedor');
      return;
    }

    setIsLoading(true);
    setProgress(0);
    setResults(null);

    try {
      console.log("🚀 Enviando archivo al backend:", file.name);
      console.log("🏢 Cliente ID:", additionalData.id_cliente);
      console.log("🍽️ Comedor ID:", additionalData.id_comedor);

      setProgress(25);

      // Enviar archivo directamente al backend usando el nuevo endpoint
      const response = await comensalApi.bulkUpload(
        file,
        additionalData.id_cliente,
        additionalData.id_comedor
      );

      console.log('✅ Respuesta del backend:', response.data);
      
      setProgress(75);

      // El backend puede devolver errores en el nivel raíz (success: false) o resultados de éxito anidados en response.data.resultados
      const responseData = response.data;
      const resultados = responseData?.resultados;

      // Caso 1: Error de validación devuelto en el nivel raíz (ej: duplicados, errores de fila)
      if (responseData && responseData.success === false) {
        const erroresDetallados = responseData.errores_detallados || [];
        if (erroresDetallados.length > 0) {
          setResults({
            total: 0,
            success: 0,
            existing: 0,
            errors: responseData.total_errores || erroresDetallados.length,
            details: erroresDetallados,
            nuevosComensales: 0,
            asignados: 0,
            yaAsignados: 0
          });
          showToast("error", `${responseData.message || "Errores de validación encontrados"}. Revise los detalles a continuación y corrija el archivo.`);
        } else {
          setResults({
            total: 0,
            success: 0,
            existing: 0,
            errors: 1,
            details: [],
            nuevosComensales: 0,
            asignados: 0,
            yaAsignados: 0
          });
          showToast("error", responseData.message || "Error en el sistema. Contacte con soporte técnico.");
        }
      // Caso 2: Error de validación anidado en .resultados
      } else if (resultados && resultados.success === false) {
        const erroresDetallados = resultados.errores_detallados || [];
        if (erroresDetallados.length > 0) {
          setResults({
            total: 0,
            success: 0,
            existing: 0,
            errors: resultados.total_errores || 0,
            details: erroresDetallados,
            nuevosComensales: 0,
            asignados: 0,
            yaAsignados: 0
          });
          showToast("error", "Errores de validación encontrados. Revise los detalles a continuación y corrija el archivo.");
        } else {
          setResults({
            total: 0,
            success: 0,
            existing: 0,
            errors: 1,
            details: [],
            nuevosComensales: 0,
            asignados: 0,
            yaAsignados: 0
          });
          showToast("error", "Error en el sistema. Contacte con soporte técnico.");
        }
      } else if (resultados) {
        // Carga exitosa normal
        setResults({
          total: resultados.total_procesados,
          success: resultados.nuevos_insertados,
          existing: resultados.existentes,
          errors: resultados.errores,
          details: resultados.detalles_errores || [],
          // Nuevos datos detallados
          nuevosComensales: resultados.comensales_nuevos || 0,
          asignados: resultados.asignados_comedor || 0,  
          yaAsignados: resultados.ya_asignados || 0
        });

        showToast("success", "Carga masiva completada exitosamente");
      } else {
        showToast("success", "Carga masiva completada exitosamente");
      }

      setProgress(100);
      
    } catch (error) {
      console.error('❌ Error en carga masiva:', error);

      // Solo manejar errores reales del sistema (no errores de validación)
      if (error.response && error.response.data) {
        const errorData = error.response.data;
        
        if (errorData.message) {
          showToast("error", errorData.message);
        } else if (errorData.error) {
          showToast("error", `Error: ${errorData.error}`);
        } else {
          showToast("error", 'Error desconocido en la carga masiva');
        }
      } else {
        showToast("error", 'Error de conexión. Verifica tu conexión a internet.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  const downloadTemplate = () => {
    // Crear template con las columnas en el orden exacto esperado por el backend
    const templateData = [
      {
        'Apellidos y Nombres': 'EJEMPLO APELLIDOS Y NOMBRES',
        'TIPO DOCUMENTO': 'DNI',
        'NUMERO DOCUMENTO': '12345678',
        'TIPO DOCUMENTO COMEDOR': 'TARJETA',
        'NUMERO DOCUMENTO COMEDOR': '87654321',
        'Cargo': 'EJEMPLO CARGO',
        'Empresa': 'EJEMPLO EMPRESA',
        'Referencia': 'EJEMPLO REFERENCIA',
        'TIPO ORIGEN TRABAJADOR': '1'
      }
    ];

    const ws = XLSX.utils.json_to_sheet(templateData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Template");
    XLSX.writeFile(wb, "template_comensales.xlsx");
    
    showToast("success", "Template descargado exitosamente");
  };

  const resetForm = () => {
    setFile(null);
    setResults(null);
    setProgress(0);
    setAdditionalData({
      id_cliente: undefined,
      id_comedor: undefined,
    });
    const fileInput = document.querySelector('input[type="file"]');
    if (fileInput) {
      fileInput.value = '';
    }
    showToast("info", "Formulario reiniciado");
  };

  return (
    <>
      {/* Digital Harmony Styles para Carga Masiva Comensales */}
      <style>
        {`
          /* Fondo y contenedor principal */
          .dh-carga-bg {
            background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
            min-height: 100vh;
          }
          
          /* Card principal con Digital Harmony */
          .dh-card-main {
            border: none;
            border-radius: 20px;
            box-shadow: 0 15px 35px rgba(0,0,0,0.1);
            background: white;
          }
          
          /* Header del card */
          .dh-card-header {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            border-radius: 20px 20px 0 0;
            padding: 1.5rem 2rem;
            border: none;
          }
          
          .dh-header-title {
            color: white;
            font-weight: 700;
            font-size: 1.5rem;
            margin: 0;
          }
          
          /* Botones con Digital Harmony */
          .btn-dh-primary {
            background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
            border: none;
            color: white;
            border-radius: 12px;
            padding: 10px 16px;
            font-weight: 600;
            box-shadow: 0 4px 14px rgba(17, 153, 142, 0.3);
            transition: all 0.3s ease;
          }
          
          .btn-dh-primary:hover {
            background: linear-gradient(135deg, #38ef7d 0%, #2dd4bf 100%);
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(17, 153, 142, 0.4);
            color: white;
          }
          
          .btn-dh-warning {
            background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
            border: none;
            color: white;
            border-radius: 12px;
            padding: 10px 16px;
            font-weight: 600;
            box-shadow: 0 4px 14px rgba(240, 147, 251, 0.3);
            transition: all 0.3s ease;
          }
          
          .btn-dh-warning:hover {
            background: linear-gradient(135deg, #f5576c 0%, #e91e63 100%);
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(240, 147, 251, 0.4);
            color: white;
          }
          
          .btn-dh-info {
            background: linear-gradient(135deg, #00c6ff 0%, #0072ff 100%);
            border: none;
            color: white;
            border-radius: 12px;
            padding: 10px 16px;
            font-weight: 600;
            box-shadow: 0 4px 14px rgba(0, 198, 255, 0.3);
            transition: all 0.3s ease;
          }
          
          .btn-dh-info:hover {
            background: linear-gradient(135deg, #0072ff 0%, #0056cc 100%);
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(0, 198, 255, 0.4);
            color: white;
          }
          
          .btn-dh-secondary {
            background: linear-gradient(135deg, #6b7280 0%, #374151 100%);
            border: none;
            color: white;
            border-radius: 12px;
            padding: 10px 16px;
            font-weight: 600;
            box-shadow: 0 4px 14px rgba(107, 114, 128, 0.3);
            transition: all 0.3s ease;
          }
          
          .btn-dh-secondary:hover {
            background: linear-gradient(135deg, #374151 0%, #1f2937 100%);
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(107, 114, 128, 0.4);
            color: white;
          }
          
          /* Formulario mejorado */
          .dh-form-container {
            background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
            border-radius: 15px;
            padding: 2rem;
            margin-bottom: 1.5rem;
          }
          
          .form-label-dh {
            font-weight: 700;
            color: #374151;
            margin-bottom: 0.75rem;
            font-size: 0.95rem;
          }
          
          .form-select-dh, .form-control-dh {
            border: 2px solid #e5e7eb;
            border-radius: 12px;
            padding: 12px 16px;
            font-size: 1rem;
            transition: all 0.3s ease;
            background: white;
            box-shadow: 0 2px 4px rgba(0,0,0,0.02);
          }
          
          .form-select-dh:focus, .form-control-dh:focus {
            border-color: #667eea;
            box-shadow: 0 0 0 0.25rem rgba(102, 126, 234, 0.15);
            background: white;
          }
          
          /* File upload section */
          .dh-upload-section {
            background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
            border: 2px dashed #16a34a;
            border-radius: 15px;
            padding: 2.5rem;
            text-align: center;
            transition: all 0.3s ease;
            margin: 1.5rem 0;
          }
          
          .dh-upload-section:hover {
            border-color: #15803d;
            background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
            transform: translateY(-2px);
          }
          
          .dh-upload-section.has-file {
            border-color: #059669;
            background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
            box-shadow: 0 8px 25px rgba(16, 185, 129, 0.1);
          }
          
          .upload-icon {
            color: #16a34a;
            margin-bottom: 1rem;
          }
          
          .upload-text {
            color: #374151;
            font-size: 1.1rem;
            font-weight: 600;
            margin-bottom: 0.5rem;
          }
          
          .upload-subtext {
            color: #6b7280;
            font-size: 0.9rem;
            margin-bottom: 1.5rem;
          }
          
          .file-selected {
            background: linear-gradient(135deg, #059669 0%, #047857 100%);
            color: white;
            padding: 12px 20px;
            border-radius: 12px;
            font-weight: 600;
            display: inline-flex;
            align-items: center;
            gap: 8px;
            margin-top: 1rem;
          }
          
          .file-selected-display {
            background: linear-gradient(135deg, #059669 0%, #047857 100%);
            color: white;
            padding: 12px 20px;
            border-radius: 12px;
            font-weight: 600;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            margin: 0.5rem;
            font-size: 1rem;
            box-shadow: 0 4px 14px rgba(5, 150, 105, 0.3);
            border: 2px solid #10b981;
            transition: all 0.3s ease;
            min-width: 180px;
            height: 44px;
          }
          
          .file-selected-display:hover {
            background: linear-gradient(135deg, #047857 0%, #065f46 100%);
            transform: translateY(-1px);
            box-shadow: 0 6px 20px rgba(5, 150, 105, 0.4);
          }
          
          /* Uniformar tamaño de botones en la sección de archivos */
          .btn-file-uniform {
            padding: 12px 20px !important;
            border-radius: 12px !important;
            font-weight: 600 !important;
            font-size: 1rem !important;
            min-width: 180px !important;
            height: 44px !important;
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            margin: 0.5rem !important;
            transition: all 0.3s ease !important;
            box-shadow: 0 4px 14px rgba(0,0,0,0.2) !important;
          }
          
          /* Alert mejorado */
          .dh-alert-info {
            background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
            border: 2px solid #3b82f6;
            border-radius: 15px;
            padding: 1.5rem;
            color: #1e40af;
            margin: 1.5rem 0;
          }
          
          .dh-alert-warning {
            background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
            border: 2px solid #f59e0b;
            border-radius: 15px;
            padding: 1rem;
            color: #92400e;
            margin: 1rem 0;
          }
          
          /* Botón de envío mejorado */
          .btn-submit-dh {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            border: none;
            color: white;
            border-radius: 12px;
            padding: 14px 24px;
            font-weight: 700;
            font-size: 1.1rem;
            box-shadow: 0 6px 20px rgba(102, 126, 234, 0.3);
            transition: all 0.3s ease;
            width: 100%;
            margin-top: 1.5rem;
          }
          
          .btn-submit-dh:hover:not(:disabled) {
            background: linear-gradient(135deg, #764ba2 0%, #8b5fbf 100%);
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);
            color: white;
          }
          
          .btn-submit-dh:disabled {
            background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%);
            cursor: not-allowed;
            transform: none;
            box-shadow: none;
          }
          
          /* Progress section */
          .dh-progress-section {
            background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
            border: 2px solid #16a34a;
            border-radius: 15px;
            padding: 2rem;
            margin-top: 2rem;
          }
          
          .progress-dh {
            height: 12px;
            border-radius: 12px;
            background: linear-gradient(135deg, #e5e7eb 0%, #d1d5db 100%);
            overflow: hidden;
            margin: 1rem 0;
          }
          
          .progress-bar-dh {
            background: linear-gradient(135deg, #16a34a 0%, #15803d 100%);
            border-radius: 12px;
            transition: width 0.5s ease;
          }
          
          /* Results section */
          .dh-results-card {
            background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
            border: 2px solid #16a34a;
            border-radius: 20px;
            margin-top: 2rem;
            overflow: hidden;
            box-shadow: 0 10px 25px rgba(16, 185, 129, 0.1);
          }
          
          .dh-results-header {
            background: linear-gradient(135deg, #16a34a 0%, #15803d 100%);
            color: white;
            padding: 1.5rem 2rem;
            border-radius: 20px 20px 0 0;
          }
          
          .dh-results-body {
            padding: 2rem;
          }
          
          .dh-stat-card {
            background: white;
            border-radius: 15px;
            padding: 1.5rem;
            text-align: center;
            box-shadow: 0 4px 15px rgba(0,0,0,0.05);
            transition: all 0.3s ease;
            border: 2px solid transparent;
          }
          
          .dh-stat-card:hover {
            transform: translateY(-3px);
            box-shadow: 0 8px 25px rgba(0,0,0,0.1);
            border-color: #667eea;
          }
          
          .stat-number {
            font-size: 2.5rem;
            font-weight: 800;
            margin-bottom: 0.5rem;
          }
          
          .stat-label {
            font-size: 0.9rem;
            font-weight: 600;
            color: #6b7280;
            text-transform: uppercase;
            letter-spacing: 0.05em;
          }
          
          /* Error table */
          .dh-error-table {
            background: white;
            border-radius: 12px;
            overflow: hidden;
            box-shadow: 0 4px 15px rgba(0,0,0,0.05);
          }

          .dh-error-table thead {
            background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
          }

          .dh-error-table thead th {
            color: white;
            font-weight: 700;
            padding: 1rem;
            border: none;
            font-size: 0.95rem;
          }

          .dh-error-table tbody td {
            padding: 1rem;
            border: none;
            border-bottom: 1px solid #f3f4f6;
            vertical-align: top;
          }

          .dh-error-table tbody tr:hover {
            background-color: #fef2f2;
          }

          .dh-error-table .badge {
            font-size: 0.85rem !important;
            padding: 0.5rem 0.75rem;
          }

          .dh-error-table ul li {
            padding: 0.25rem 0;
            font-size: 0.9rem;
          }
        `}
      </style>
      
      <div className="dh-carga-bg">
        <div className="container-fluid py-4">
          <ToastContainer />
          <div className="dh-card-main">
            <div className="dh-card-header">
              <div className="d-flex justify-content-between align-items-center">
                <h5 className="dh-header-title">Carga Masiva de Comensales</h5>
                <div className="btn-group">
                  <button
                    type="button"
                    className="btn-dh-info d-flex align-items-center gap-2"
                    onClick={downloadTemplate}
                    title="Descargar plantilla Excel"
                  >
                    <MdDownload size={20} />
                    Descargar Template
                  </button>
                  <button
                    type="button"
                    className="btn-dh-warning d-flex align-items-center gap-2"
                    onClick={resetForm}
                    disabled={isLoading}
                    title="Limpiar formulario"
                  >
                    <MdRefresh size={20} />
                    Limpiar
                  </button>
                  <button 
                    className="btn-dh-secondary d-flex align-items-center gap-2" 
                    onClick={() => navigate("/home")}
                    title="Volver al inicio"
                  >
                    <MdLogout size={20} />
                    Cerrar
                  </button>
                </div>
              </div>
            </div>

            <div className="card-body" style={{ padding: '2rem' }}>
              <form onSubmit={handleSubmit}>
                <div className="dh-form-container">
                  <div className="row">
                    {/* Selección de Cliente */}
                    <div className="col-md-6 mb-4">
                      <label htmlFor="id_cliente" className="form-label-dh">
                        Cliente <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-select-dh"
                        id="id_cliente"
                        name="id_cliente"
                        value={additionalData.id_cliente || ""}
                        onChange={handleInputChange}
                        required
                        disabled={isLoading}
                      >
                        <option value="">Seleccione un cliente</option>
                        {clientes.map((cliente) => (
                          <option key={cliente.id} value={cliente.id}>
                            {cliente.nombre}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Selección de Comedor */}
                    <div className="col-md-6 mb-4">
                      <label htmlFor="id_comedor" className="form-label-dh">
                        Comedor <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-select-dh"
                        id="id_comedor"
                        name="id_comedor"
                        value={additionalData.id_comedor || ""}
                        onChange={handleInputChange}
                        required
                        disabled={isLoading}
                      >
                        <option value="">Seleccione un comedor</option>
                        {comedores.map((comedor) => (
                          <option key={comedor.id} value={comedor.id}>
                            {comedor.nombre}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                {/* Archivo Excel */}
                <div className="row">
                  <div className="col-12">
                    <label className="form-label-dh">
                      Archivo Excel <span className="text-danger">*</span>
                    </label>
                    
                    {/* Información sobre columnas requeridas */}
                    <div className="alert alert-info mb-3" style={{ 
                      backgroundColor: '#e7f3ff', 
                      border: '1px solid #b3d9ff', 
                      borderRadius: '8px',
                      padding: '1rem'
                    }}>
                      <strong>📋 Formato del archivo Excel:</strong>
                      <p className="mb-2 mt-2">El archivo debe tener las siguientes columnas en este orden exacto:</p>
                      <div className="row">
                        <div className="col-md-6">
                          <ol className="mb-2" style={{ paddingLeft: '1.5rem' }}>
                            <li><strong>APELLIDOS Y NOMBRES</strong> <span className="text-danger">(requerido)</span></li>
                            <li><strong>TIPO DOCUMENTO</strong> <span className="text-danger">(requerido)</span></li>
                            <li><strong>NUMERO DOCUMENTO</strong> <span className="text-danger">(requerido)</span></li>
                            <li><strong>TIPO DOCUMENTO COMEDOR</strong> <span className="text-danger">(requerido)</span></li>
                            <li><strong>NUMERO DOCUMENTO COMEDOR</strong> <span className="text-danger">(requerido)</span></li>
                          </ol>
                        </div>
                        <div className="col-md-6">
                          <ol start="6" className="mb-2" style={{ paddingLeft: '1.5rem' }}>
                            <li><strong>CARGO</strong> <span className="text-muted">(opcional)</span></li>
                            <li><strong>EMPRESA</strong> <span className="text-muted">(opcional)</span></li>
                            <li><strong>REFERENCIA</strong> <span className="text-muted">(opcional)</span></li>
                            <li><strong>TIPO ORIGEN TRABAJADOR</strong> <span className="text-danger">(requerido: 1=Local, 2=Foráneo)</span></li>
                          </ol>
                        </div>
                      </div>
                      <div className="dh-alert-warning mt-3" style={{backgroundColor: '#fff3cd', border: '1px solid #ffc107', borderRadius: '8px', padding: '0.75rem'}}>
                        <small>
                          <strong>Importante:</strong> Los nombres de las columnas deben ser exactos (case-insensitive). 
                          Las primeras 5 columnas y TIPO ORIGEN TRABAJADOR son obligatorias. 
                          Use el template para asegurar el formato correcto.
                        </small>
                      </div>
                    </div>
                    
                    <div className={`dh-upload-section ${file ? 'has-file' : ''}`}>
                      <MdCloudUpload size={64} className="upload-icon" />
                      <input
                        type="file"
                        id="excel_file"
                        accept=".xlsx,.xls"
                        onChange={handleFileChange}
                        required
                        disabled={isLoading || file}
                        style={{ display: 'none' }}
                      />
                      {!file ? (
                        <>
                          <div className="upload-text">Seleccione su archivo Excel</div>
                          <div className="upload-subtext">Formatos soportados: .xlsx, .xls</div>
                          <label 
                            htmlFor="excel_file" 
                            className="btn-dh-primary btn-file-uniform" 
                            style={{ cursor: (isLoading || isValidating) ? 'not-allowed' : 'pointer' }}
                          >
                            {isValidating ? (
                              <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Validando...
                              </>
                            ) : (
                              <>
                                <MdUpload size={20} className="me-2" />
                                Examinar Archivos
                              </>
                            )}
                          </label>
                        </>
                      ) : (
                        <>
                          <div className="upload-text">
                            {isFileValid ? "Archivo validado correctamente" : "Archivo seleccionado"}
                          </div>
                          <div className="upload-subtext">
                            <strong>Archivo cargado:</strong>
                          </div>
                          <div className="d-flex flex-column align-items-center">
                            <div className={`file-selected-display ${isFileValid ? '' : 'bg-warning'}`}>
                              <i className={`fas ${isFileValid ? 'fa-check-circle' : 'fa-exclamation-triangle'} me-2`}></i>
                              {file.name}
                            </div>
                            {isFileValid && (
                              <div className="alert alert-success mt-2 mb-0" style={{ padding: '0.5rem 1rem', fontSize: '0.9rem' }}>
                                <i className="fas fa-check-circle me-2"></i>
                                El archivo cumple con todos los requisitos
                              </div>
                            )}
                            <button
                              type="button"
                              className="btn-dh-warning btn-file-uniform"
                              onClick={() => {
                                setFile(null);
                                setResults(null);
                                setFileValidationErrors([]);
                                setIsFileValid(false);
                                const fileInput = document.querySelector('input[type="file"]');
                                if (fileInput) {
                                  fileInput.value = '';
                                }
                              }}
                              disabled={isLoading || isValidating}
                            >
                              <i className="fas fa-times me-2"></i>
                              Cambiar Archivo
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                {/* Errores de validación del archivo */}
                {fileValidationErrors.length > 0 && (
                  <div className="mt-4">
                    <div className="alert alert-danger">
                      <h6 className="alert-heading fw-bold">
                        <i className="fas fa-exclamation-triangle me-2"></i>
                        Errores de Validación del Archivo Excel
                      </h6>
                      <p className="mb-3">
                        <strong>⚠️ El archivo no puede ser procesado:</strong> Corrija los siguientes errores antes de intentar cargar el archivo.
                      </p>
                      <div className="table-responsive mt-3">
                        <table className="dh-error-table table mb-0">
                          <thead className="table-dark">
                            <tr>
                              <th style={{ width: '100px', backgroundColor: '#343a40', color: '#ffffff' }}>📍 Fila Excel</th>
                              <th style={{ backgroundColor: '#343a40', color: '#ffffff' }}>🚫 Errores de Validación</th>
                            </tr>
                          </thead>
                          <tbody>
                            {fileValidationErrors.map((error, index) => (
                              <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#f8f9fa' : '#ffffff' }}>
                                <td className="fw-bold text-center" style={{ backgroundColor: index % 2 === 0 ? '#f8f9fa' : '#ffffff' }}>
                                  <span className="badge bg-danger fs-6">{error.fila}</span>
                                </td>
                                <td style={{ backgroundColor: index % 2 === 0 ? '#f8f9fa' : '#ffffff' }}>
                                  <ul className="list-unstyled mb-0">
                                    {Array.isArray(error.errores)
                                      ? error.errores.map((err, idx) => (
                                          <li key={idx} className="mb-1" style={{ color: '#dc3545' }}>
                                            <i className="fas fa-times-circle text-danger me-2"></i>
                                            {err}
                                          </li>
                                        ))
                                      : (
                                          <li style={{ color: '#dc3545' }}>
                                            <i className="fas fa-times-circle text-danger me-2"></i>
                                            {error.errores}
                                          </li>
                                        )
                                    }
                                  </ul>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )}

                {/* Botón de envío */}
                <button
                  type="submit"
                  className="btn-submit-dh d-flex align-items-center justify-content-center gap-2"
                  disabled={isLoading || isValidating || !file || !isFileValid || !additionalData.id_cliente || !additionalData.id_comedor}
                >
                  {isLoading ? (
                    <>
                      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      Procesando archivo...
                    </>
                  ) : isValidating ? (
                    <>
                      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      Validando archivo...
                    </>
                  ) : (
                    <>
                      <MdUpload size={24} />
                      Cargar Comensales
                    </>
                  )}
                </button>
              </form>

              {/* Barra de progreso */}
              {isLoading && (
                <div className="dh-progress-section">
                  <h6 className="fw-bold mb-3 text-center">
                    <i className="fas fa-cog fa-spin me-2"></i>
                    Procesando archivo...
                  </h6>
                  <div className="progress-dh">
                    <div
                      className="progress-bar-dh progress-bar-striped progress-bar-animated"
                      role="progressbar"
                      style={{ width: `${progress}%` }}
                      aria-valuenow={progress}
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                  <div className="text-center">
                    <span className="fw-bold">{progress}% completado</span>
                  </div>
                </div>
              )}

              {/* Resultados */}
              {results && (
                <div className="dh-results-card">
                  <div className="dh-results-header">
                    <h5 className="mb-0 fw-bold">
                      <i className="fas fa-chart-bar me-2"></i>
                      Resultados de la Carga
                    </h5>
                  </div>
                  <div className="dh-results-body">
                    {/* Primera fila - Total */}
                    <div className="row mb-3">
                      <div className="col-md-12">
                        <div className="dh-stat-card" style={{backgroundColor: '#f8f9fa', border: '2px solid #dee2e6'}}>
                          <div className="stat-number text-primary" style={{fontSize: '3rem'}}>{results.total}</div>
                          <div className="stat-label" style={{fontSize: '1.1rem', fontWeight: 'bold'}}>TOTAL PROCESADOS</div>
                        </div>
                      </div>
                    </div>
                    
                    {/* Segunda fila - Detalles */}
                    <div className="row">
                      <div className="col-md-3 mb-4">
                        <div className="dh-stat-card">
                          <div className="stat-number text-success">{results.nuevosComensales}</div>
                          <div className="stat-label">Comensales Nuevos</div>
                        </div>
                      </div>
                      <div className="col-md-3 mb-4">
                        <div className="dh-stat-card">
                          <div className="stat-number text-info">{results.asignados}</div>
                          <div className="stat-label">Asignados al Comedor</div>
                        </div>
                      </div>
                      <div className="col-md-3 mb-4">
                        <div className="dh-stat-card">
                          <div className="stat-number text-warning">{results.yaAsignados}</div>
                          <div className="stat-label">Ya Estaban Asignados</div>
                        </div>
                      </div>
                      <div className="col-md-3 mb-4">
                        <div className="dh-stat-card">
                          <div className="stat-number text-danger">{results.errors}</div>
                          <div className="stat-label">Errores</div>
                        </div>
                      </div>
                    </div>

                    {/* Detalles de errores */}
                    {(results.details && results.details.length > 0) && (
                      <div className="mt-4">
                        <div className="alert alert-danger">
                          <h6 className="alert-heading fw-bold">
                            <i className="fas fa-exclamation-triangle me-2"></i>
                            Errores de Validación Encontrados ({results.details.length} filas con problemas)
                          </h6>
                          <p className="mb-3">
                            <strong>⚠️ Carga Cancelada:</strong> Corrija los siguientes errores en el archivo Excel y vuelva a intentar la carga.
                          </p>
                          <div className="table-responsive mt-3">
                            <table className="dh-error-table table mb-0">
                              <thead className="table-dark">
                                <tr>
                                  <th style={{ width: '100px', backgroundColor: '#343a40', color: '#ffffff' }}>📍 Fila Excel</th>
                                  <th style={{ backgroundColor: '#343a40', color: '#ffffff' }}>🚫 Errores de Validación</th>
                                </tr>
                              </thead>
                              <tbody>
                                {results.details.map((error, index) => (
                                  <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#f8f9fa' : '#ffffff' }}>
                                    <td className="fw-bold text-center" style={{ backgroundColor: index % 2 === 0 ? '#f8f9fa' : '#ffffff' }}>
                                      <span className="badge bg-danger fs-6">{error.fila}</span>
                                    </td>
                                    <td style={{ backgroundColor: index % 2 === 0 ? '#f8f9fa' : '#ffffff' }}>
                                      <ul className="list-unstyled mb-0">
                                        {Array.isArray(error.errores)
                                          ? error.errores.map((err, idx) => (
                                              <li key={idx} className="mb-1" style={{ color: '#dc3545' }}>
                                                <i className="fas fa-times-circle text-danger me-2"></i>
                                                {err}
                                              </li>
                                            ))
                                          : (
                                              <li style={{ color: '#dc3545' }}>
                                                <i className="fas fa-times-circle text-danger me-2"></i>
                                                {error.errores}
                                              </li>
                                            )
                                        }
                                      </ul>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                            {results.details.length > 10 && (
                              <div className="text-center mt-2">
                                <small className="text-muted">
                                  ... y {results.details.length - 10} errores más
                                </small>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                    
                    {/* Fallback: Mostrar errores de manera simple si la tabla no se muestra */}
                    {results.errors > 0 && (!results.details || results.details.length === 0) && (
                      <div className="mt-4">
                        <div className="alert alert-warning">
                          <h6 className="alert-heading fw-bold">
                            <i className="fas fa-exclamation-triangle me-2"></i>
                            Errores de Validación Encontrados
                          </h6>
                          <p className="mb-0">
                            <strong>Total de errores:</strong> {results.errors}
                          </p>
                          <p className="mb-0">
                            <strong>Mensaje:</strong> Por favor, revise el archivo Excel y corrija los errores antes de volver a cargar.
                          </p>
                        </div>
                      </div>
                    )}
                    
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CargaMasivaComensales;
